import React from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { SectionCta } from '../components/SectionCta';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-navy-950 py-14 sm:py-20" aria-labelledby="bonuses-heading" data-id="element-128" data-mp="1wcxngrq0rtct">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-129" data-mp="21b8uyvsudrrv">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-300" data-id="element-130" data-mp="219ea1hhklzns">
          But there’s more…
        </p>
        <h2 id="bonuses-heading" className="mx-auto mt-3 max-w-2xl text-center font-display text-[26px] font-black leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-131" data-mp="2t36meav4n11m">
          Today you’ll also receive 5 exclusive bonuses
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-brand-100 sm:text-lg" data-id="element-132" data-mp="2k3t9t9bphwco">
          These aren’t random extras. They’re practical tools designed to make the system
          faster and easier to apply in your daily workflow.
        </p>

        <div className="mt-10 space-y-5 sm:space-y-6" data-id="element-133" data-mp="3drb4fl6d7z5e">
          {bonuses.map((bonus, i) => <article key={bonus.index} className="overflow-hidden rounded-2xl bg-white shadow-card" data-id="element-134" data-mp="39qse5vk4f15b" data-mpi={i}>
              <div className="grid md:grid-cols-2" data-id="element-135" data-mp="3iq5o0pc5prqk">
                <div className={`bg-brand-50 px-4 py-5 sm:px-6 sm:py-7 ${i % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-136" data-mp="3iob3vd8pm3nj">
                  <img src={bonus.image} alt={`${bonus.title} — ${bonus.index} digital mockup shown on desktop, tablet and mobile`} className="mx-auto w-full max-w-[420px]" width={1256} height={1256} loading="lazy" data-id="element-137" data-mp="3snacwwxe01b2" />
                </div>

                <div className="flex flex-col p-5 sm:p-7" data-id="element-138" data-mp="f9p2xjmrivnp">
                  <div className="flex items-center gap-2" data-id="element-139" data-mp="f7cdymil7l15">
                    <GiftIcon aria-hidden="true" className="h-4 w-4 text-brand-600" data-id="element-140" data-mp="mdolurmaf55r" />
                    <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-brand-600" data-id="element-141" data-mp="raoqcy3hnzur">
                      {bonus.index}
                    </span>
                  </div>
                  <h3 className="mt-3 font-display text-[20px] font-extrabold leading-tight tracking-tight text-navy-900 sm:text-[24px]" data-id="element-142" data-mp="111jg4cfy1hky">
                    {bonus.title}
                  </h3>
                  <p className="mt-1.5 text-[12.5px] font-bold uppercase tracking-wide text-brand-700" data-id="element-143" data-mp="1a1eueq4spsp7">
                    {bonus.subtitle}
                  </p>
                  <p className="mt-3 text-[14px] leading-relaxed text-ink-700" data-id="element-144" data-mp="1ez81dldxaqqj">{bonus.body}</p>

                  {bonus.bullets ? <ul className="mt-4 flex flex-wrap gap-2" data-id="element-145" data-mp="3gsxhm4r58aqo">
                      {bonus.bullets.map(bullet => <li key={bullet} className="flex items-center gap-1.5 rounded-full bg-brand-50 px-2.5 py-1 text-[12px] font-semibold text-navy-900" data-id="element-146" data-mp="3lsk0atpqqj6v">
                          <CheckIcon aria-hidden="true" className="h-3 w-3 text-brand-600" data-id="element-147" data-mp="39f6gu8co9wci" />
                          {bullet}
                        </li>)}
                    </ul> : null}

                  <div className="mt-auto flex flex-wrap items-center gap-2 pt-5" data-id="element-148" data-mp="116676l4r12e">
                    <span className="rounded-md bg-navy-900/5 px-2.5 py-1 text-[12px] font-bold text-ink-700 line-through decoration-red-500 decoration-2" data-id="element-149" data-mp="3s7r5tep93hb1">
                      Value: {bonus.value}
                    </span>
                    <span className="rounded-md bg-emerald-500 px-2.5 py-1 text-[11.5px] font-bold uppercase tracking-wide text-white" data-id="element-150" data-mp="3ia30juu0qrem">
                      Included free today
                    </span>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCta label="Claim the 5 bonuses now" sub="All bonuses are included at no extra cost today." variant="light" data-id="element-151" data-mp="3vnk9ad332n4e" />
      </div>
    </section>;
}